import React from 'react';

export function TaskExecutor({ fill = '#818998' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_3165_14020)">
                <path
                    d="M15.996 6.78989C15.9825 6.57325 15.9263 6.36142 15.8307 6.16658C15.735 5.97174 15.6018 5.79772 15.4387 5.65455L10.8506 1.50189C8.14465 -0.866113 5.38265 0.0798867 4.29865 0.91122L3.65998 1.40122L7.49998 4.82589L0.0493164 13.3452L3.06132 15.9779L10.4846 7.48855L12.3587 9.15989C12.5231 9.30455 12.7146 9.41511 12.922 9.48515C13.1295 9.55519 13.3489 9.58332 13.5673 9.56789C13.7858 9.55361 13.9993 9.49625 14.1955 9.39911C14.3918 9.30197 14.5668 9.16697 14.7107 9.00189L15.588 7.99789C15.7326 7.83356 15.8431 7.64217 15.9131 7.4348C15.9832 7.22743 16.0113 7.00822 15.996 6.78989ZM9.96465 2.49722L12.822 5.08389L11.494 6.60189L5.85398 1.57122C6.72598 1.23189 8.26532 1.01122 9.96465 2.49722ZM2.93465 14.0966L1.93065 13.2192L8.49532 5.71389L9.48998 6.60122L2.93465 14.0966ZM14.584 7.12055L13.7066 8.12455C13.6484 8.19092 13.5661 8.23144 13.478 8.23722C13.4355 8.2408 13.3928 8.23586 13.3522 8.22269C13.3117 8.20953 13.2742 8.1884 13.242 8.16055L12.49 7.48989L13.8113 5.97922L14.5527 6.65055C14.5859 6.67912 14.6132 6.71404 14.6328 6.75326C14.6524 6.79248 14.664 6.83522 14.6669 6.87898C14.6699 6.92274 14.664 6.96664 14.6498 7.00812C14.6355 7.0496 14.6132 7.08782 14.584 7.12055Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_3165_14020">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
